export const FRESHDESK_FAQS = {
  DEFAULT: '80000008038',
  SMM: '80000009440',
};
